import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Divider } from '@mui/material';
import { ACLPermissions } from 'shared/device.acl/ui/permissions';
import { Until } from 'shared/device.acl/ui/until';
import { NotBefore } from 'shared/device.acl/ui/not-before';
import { WeekSchedule } from 'shared/device.acl/ui/weekschedule';
import { ColumnBox } from 'shared/components/containers';
import { useUnpackEditingProps, } from 'z3k-settings/components/utils/unpack-props';
import { paseWeek } from 'console/shared/device.acl/utils';
export const getAclFormItem = (acl) => ({
    week_schedule: paseWeek(acl),
    perms: acl?.perms ?? [],
    until: acl?.until != null ? acl.until : null,
    not_before: acl?.not_before != null ? acl.not_before : null,
});
export const ACLItemContent = memo(function ACLItemContent(props) {
    const { readonly, show_gps, children } = props;
    const permsEditingProps = useUnpackEditingProps(props, 'perms');
    const untilEditingProps = useUnpackEditingProps(props, 'until');
    const notBeforeEditingProps = useUnpackEditingProps(props, 'not_before');
    const weekScheduleEditingProps = useUnpackEditingProps(props, 'week_schedule');
    return (_jsxs(ColumnBox, { children: [children, _jsx(ACLPermissions, { ...permsEditingProps, can_edit_settings: readonly, show_gps: show_gps }), _jsx(Divider, {}), _jsx(Until, { ...untilEditingProps, readonly: readonly }), _jsx(NotBefore, { ...notBeforeEditingProps, readonly: readonly }), _jsx(WeekSchedule, { ...weekScheduleEditingProps, readonly: readonly })] }));
});
